function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "error");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "error"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.5,34.05a2.5,2.5,0,0,1-2.5-2.5v-14a2.5,2.5,0,0,1,5,0V31.55A2.5,2.5,0,0,1,29.5,34.05Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.5,44A2.5,2.5,0,0,1,27,41.5V40.33a2.5,2.5,0,0,1,5,0V41.5A2.5,2.5,0,0,1,29.5,44Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.5,59A29.5,29.5,0,1,1,59,29.5,29.53,29.53,0,0,1,29.5,59Zm0-54A24.5,24.5,0,1,0,54,29.5,24.53,24.53,0,0,0,29.5,5Z"
}))));

var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 59 59",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert.8cfa5e99.svg";
export { ForwardRef as ReactComponent };